import { createStation } from "@station-keeping/sim";
import { GameEngine } from "./engine";
import { setEngine } from "./runtime";

/**
 * Bac à sable : une station locale, sans serveur ni sauvegarde, dont on peut accélérer le temps. Sert au
 * développement (rendu, équilibrage ressenti) ; le jeu normal ouvre une session sur le serveur.
 */
export function startSandbox(seed = `bac-a-sable-${Date.now().toString(36)}`): GameEngine {
  const clock = { now: () => performance.now() };
  const engine = new GameEngine(createStation(seed.slice(0, 64)), { tick: 0, at: clock.now() }, clock);
  setEngine(engine);
  return engine;
}
